import {addBrowserSideAppHeaders} from '@/utils/unityHeaders';
import getGameId from '@/utils/getGameId';
import AppsFlyerUtils from './AppsFlyerUtils';
import {fetchWithRetry} from '@/utils/fetchWithRetry';

export default async function loginUserWithUserName(username: string, password: string) {
  const headers = {};
  await addBrowserSideAppHeaders(headers);
  headers['User-Agent'] = navigator.userAgent;
  const gid = getGameId();

  const res = await fetchWithRetry('/api/login', {
    method: 'POST',
    body: JSON.stringify({username, password, gid}),
    headers: headers,
  });
  AppsFlyerUtils.sendIdentityLink();
  return await res.json();
}
